<span class="flex items-center p-2 w-max gap-2 rounded-md shadow-sm bg-{{ color }}-100 text-{{ color }}-600">
    <mat-icon *ngIf="iconName" class="text-{{ color }}-600">{{ iconName }}</mat-icon>
    <span class="font-medium" [class.text-sm]="small">{{ text }}</span>
</span>